<template>
    
</template>

<script>
    import BackgroundImageMixin from './BackgroundImageMixin';
    import BackgroundVideoMixin from './BackgroundVideoMixin';
    import BackgroundColorMixin from './BackgroundColorMixin';
    import BackgroundEmbedMixin from './BackgroundEmbedMixin.vue';

    export default {
        name: "BackgroundMediaMixin",
        mixins: [
            BackgroundVideoMixin,
            BackgroundImageMixin,
            BackgroundColorMixin,
            BackgroundEmbedMixin
        ],
        computed : {
            getSelectedMedia(){
                return this.myData?.selectedMedia;
            }
        },
        methods: {
            setSelectedMedia(value){

                this.changeMyData({selectedMedia: value});
                this.setChangesAreSaved(false);
                if (value) {
                    this[`show${value}`](); // showColor , showImage , showVideo , showEmbed
                }
            }
        }
    }
</script>

